import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi } from "../components/Utility";
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
} from "mobx";
import config from '../config'

class AssignVehicleToUserStore {
  total = 0;
  loading = false;

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
    
      addData: action,
    });
    this.rootStore = rootStore;
  }

  async addData(data) {
    console.log("data", data);
   
    if(config.pythonReport==1)
    { 
       var response = await postApi
      .getClient()
      .post(config.NodeUrl + "/users/userAssignVehicle", {
        postData:data
      });
    }
    else{
      var postData = data;
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
      .getClient()
      .post("index.php?c=user&a=usergroup", "postData=" + base64Input);
    }    
   
    console.log(response);
    return response;
  }

  async getAllUserVehicleFunc({companyId,userId,isadmin}){
    var postData ={"ruleId":"","addedByUserId":"","companyId":companyId,"userId":userId,"isadmin":isadmin}
    const base64Input = await base64_encode(JSON.stringify(postData));
    if(config.pythonReport==1){
       var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/users/getAllUserVehicles", {
        params:postData
      });
      
    }else{
         var response = await postApi
          .getClient()
          .post("index.php?c=vehicle&a=getAllUserVehicles", "postData=" + base64Input);
        console.log(response);
    }
    return response.data?.data;
  }
}

export default AssignVehicleToUserStore;
